/**
 * Maps quizrun events to local cover photos.
 *
 * Photos live in /images/events/ and are named by season/theme.
 * Covers are keyed by the immutable quizrun database ID.
 */

const DEFAULT_ALT = "Quizrun event";

const coverByQuizrunId: Record<number, string> = {
  1: "/images/events/summer-park-group-sm.webp",
  2: "/images/events/summer-starting-line-sm.webp",
  3: "/images/events/autumn-off-they-go-sm.webp",
  4: "/images/events/autumn-team-thumbs-up-sm.webp",
  5: "/images/events/autumn-hyde-park-amir_question-sm.webp",
  6: "/images/events/winter-group-wave-sm.webp",
  7: "/images/events/spring-laptop-results-sm.webp",
  8: "/images/events/spring-prague-sm.webp",
  9: "/images/events/spring-getting-ready-sm.webp",
  11: "/images/events/spring-team-photo-sm.webp",
  12: "/images/events/may-kew-group-sm.webp",
  13: "/images/events/june-park-picnic-sm.webp",
  14: "/images/events/summer-hyde-park-sprint-start-sm.webp",
  15: "/images/events/quizrun-12-august-2026-sm.webp",
  16: "/images/events/quizrun-13-september-2026-sm.webp",
  18: "/images/events/quizrun-trail-august-2026-sm.webp",
};

export interface CoverPhoto {
  src: string;
  alt: string;
}

/** Get the cover photo for a quizrun, if one exists. */
export function getCoverPhoto(quizrunId: number): CoverPhoto | null {
  const src = coverByQuizrunId[quizrunId];
  return src ? { src, alt: DEFAULT_ALT } : null;
}
